module.exports = __webpack_public_path__ + "static/media/arrow-down.d8fa930f.svg";